import type { CountdownTimerPropsType, TimeLeftType } from '../types'

export const calculateTimeLeft = (
  props: CountdownTimerPropsType,
): TimeLeftType => {
  if (props.remainingMilliseconds <= 0)
    return { hours: 0, minutes: 0, seconds: 0 }

  const hours = Math.floor(props.remainingMilliseconds / (1000 * 60 * 60))
  const minutes = Math.floor(
    (props.remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60),
  )
  const seconds = Math.floor((props.remainingMilliseconds % (1000 * 60)) / 1000)

  return { hours, minutes, seconds }
}
